import { createApp } from "vue";
import App from "./App.vue";
import ElementPlus from "element-plus";
import "zhihao-ui/dist/index.css";
import "@/views/styles/layout.scss";
import "@/views/styles/_global.scss";
import "@/views/styles/reset.scss";
import "@/views/styles/common.scss";
import "@/views/styles/_flex.scss";
import "@/views/styles/_spacing.scss";
import "@/views/styles/_grid.scss";
// custom element css
import "@/views/styles/element.scss";
import "@/views/assets/iconfont/iconfont.css";
// element icons
import * as Icons from "@element-plus/icons-vue";
// custom directives
import directives from "@/views/directives/index";
// vue Router
import router from "@/routers";
// pinia store
import pinia from "@/stores";
// 预加载全局组件
import * as preComp from "@/utils/preComp";

const app = createApp(App);

Object.keys(preComp).forEach(key => {
    app.component(key, preComp[key as keyof typeof preComp]);
});

// register the element Icons component
Object.keys(Icons).forEach(key => {
    app.component(key, Icons[key as keyof typeof Icons]);
});

app.use(directives).use(router).use(ElementPlus).use(pinia).mount("#app");
